import React from 'react'
import { Link } from 'react-router-dom'
import { useModal } from '../../contexts/ModalContext';

export default function PetfriendlyPoint() {
    const { openQueryModal } = useModal();

  return (
    <>
    <section className='petpage-point'>
        <img src='/image/petfriendly-point.webp' className='img-responsive' alt='pet-friendly' />
        
        <div className='container'>
            <div className='row '>
                <div className='col-lg-6 col-md-6 wow animate__animated animate__slideInUp'>
                    <div className="petpoint-box">
                        <h3 className='heading'>Good To Know For Pet-Friendly Stays</h3>
                        <p>Pet-friendly stays at De Coracao Resort are designed to feel relaxed and thoughtful, with a few simple guidelines to ensure a comfortable experience for all guests.</p>

                        <ul>
                            <li>Pets are allowed only in designated Ground Floor Cottages (Luxury Cottage & Family Cottage). </li>
                            <li>A maximum of one pet per cottage is permitted, with a one-time pet fee of ₹1,500. </li>
                            <li>Pets are not allowed in the swimming pool, reception, or restaurant areas.</li>
                            <li>Pet owners must ensure their pets do not disturb other guests and are responsible for any damage or injury caused by their pets. </li>
                            <li>Pet food and supplies are available on advance request through the Reservations or Reception Desk at an additional charge. Guests may also order food from the Pet Menu.</li>
                        </ul>
                        
                        <p>If you have any questions before booking, our team is always happy to help.</p>

                        <Link onClick={openQueryModal} className="arrow-butn">Enquire Now <img src="/image/right-arrow.svg" alt="arrow" /></Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
